import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";
import { Bridge } from "@/lib/ipc/bridge";
import { getBridge } from "@/lib/ipc/util";
import {
	type Action,
	getInitialAction,
	getInitialState,
	partialize,
	type State,
	storeName,
} from "@/lib/store/appSettingsStore.init";
import { createCustomStorage } from "@/lib/store/util";

const storeBridge = getBridge(Bridge.Store);

const useAppSettingsStore = storeBridge
	? create<State & Action>((_set) => {
			const set = (v) => {
				if (typeof v === "function") {
					v = v();
				}

				storeBridge.dispatch?.(v, storeName);
			};

			return {
				...getInitialState(),
				...getInitialAction(set),
			};
		})
	: create(
			persist(
				(set) => {
					return {
						...getInitialState(),
						...getInitialAction(set),
					};
				},
				{
					version: 0,
					name: storeName,
					storage: createJSONStorage(() => {
						return createCustomStorage();
					}),
					partialize,
				},
			),
		);

storeBridge?.onUpdate?.((state, _storeName) => {
	if (_storeName === storeName) {
		useAppSettingsStore.setState(state);
	}
});

export { useAppSettingsStore };
